import axios from 'axios';
// import store from '@/store';

// axios.defaults.baseURL = process.env.VUE_APP_API_URI
// axios.defaults.headers.common['Authorization'] = store.state.token;

const apiStormwatch = 'https://api22-stormwatch.previmeteo.net'
const apiMy = process.env.VUE_APP_API_URI;

const getData = e => e.data;

const api = {
    rainviewer:{
        getTiles:()=>
            axios.get(`${apiMy}/rainviewer/weather`).then(getData)
    },
    users:{
        login:(data)=>
            axios.post(`${apiStormwatch}/token`, {headers:{'Authorization':'9730dcc79b0985960254d77920332790'}}, data).then(getData),
        getOne:(id)=>
            axios.get(`${apiStormwatch}/users/${id}`, {headers:{'Authorization':'9730dcc79b0985960254d77920332790'}}).then(getData),
        get:()=>
            axios.get(`${apiStormwatch}/users/list`, {headers:{'Authorization':'9730dcc79b0985960254d77920332790'}}).then(getData),
        getSubs:(user_id)=>
            axios.get(`${apiStormwatch}/subs/${user_id}`, {headers:{'Authorization':'9730dcc79b0985960254d77920332790'}}).then(getData),
        create:(data)=>
            axios.post(`${apiStormwatch}/users`, {headers:{'Authorization':'9730dcc79b0985960254d77920332790'}}, data).then(getData),
        update:(id,data)=>
            axios.put(`${apiStormwatch}/users/${id}`, {headers:{'Authorization':'9730dcc79b0985960254d77920332790'}}, data).then(getData),
        updateViewNews:(id)=>
            axios.put(`${apiStormwatch}/user/${id}/view_news`,null ,{headers:{'Authorization':'9730dcc79b0985960254d77920332790'}}).then(getData)
    },
    alerts:{
        create:(data)=>
            axios.post(`/alerts`, {headers:{'Authorization':'9730dcc79b0985960254d77920332790'}}, data).then(getData)
    }
}

export default api;
